// ============================================================
//  NETWORK CONFIG  —  YOU control the network HERE (in code).
//  The user never sees which network is selected.
//  Switch ACTIVE_NETWORK between 'mainnet' and 'testnet'.
// ============================================================

// >>> CHANGE THIS ONE LINE to flip the whole app's network <<<
export const ACTIVE_NETWORK = 'mainnet'; // 'mainnet' | 'testnet'

export const NETWORKS = {
  mainnet: {
    key: 'mainnet',
    chainId: 56,
    chainIdHex: '0x38',
    chainName: 'BNB Smart Chain',
    nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
    rpcUrls: [
      'https://bsc-dataseed.binance.org',
      'https://bsc-dataseed1.defibit.io',
      'https://bsc-dataseed1.ninicoin.io',
    ],
    // Logs-capable RPC (dataseed nodes reject eth_getLogs). Used for event history.
    logsRpc: 'https://bsc-rpc.publicnode.com',
    blockExplorerUrls: ['https://bscscan.com'],
  },
  testnet: {
    key: 'testnet',
    chainId: 97,
    chainIdHex: '0x61',
    chainName: 'BNB Smart Chain',
    nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
    rpcUrls: [
      'https://data-seed-prebsc-1-s1.binance.org:8545',
      'https://data-seed-prebsc-2-s1.binance.org:8545',
    ],
    // Logs-capable RPC (dataseed rejects eth_getLogs entirely).
    logsRpc: 'https://bsc-testnet.publicnode.com',
    blockExplorerUrls: ['https://bscscan.com'],
  },
};

export const ACTIVE = NETWORKS[ACTIVE_NETWORK];

// Params formatted for wallet_addEthereumChain
export const ADD_CHAIN_PARAMS = {
  chainId: ACTIVE.chainIdHex,
  chainName: ACTIVE.chainName,
  nativeCurrency: ACTIVE.nativeCurrency,
  rpcUrls: ACTIVE.rpcUrls,
  blockExplorerUrls: ACTIVE.blockExplorerUrls,
};

export const EXPLORER = ACTIVE.blockExplorerUrls[0];
export const LOGS_RPC = ACTIVE.logsRpc;
// Max block range the logs RPC accepts per eth_getLogs call.
export const LOGS_CHUNK = 49000;
